import { useAtomValue } from 'jotai'
import { useState } from 'react'
import {
  errorAtom,
  isSuccessAtom,
  isUserRejectionErrorAtom,
} from '@/src/stores/route-machine/atoms'
import { getErrorToDisplay } from '@/src/utils/error'
import { TradeErrorMessage } from '../route-details/trade-error-message'
import { BasicStep } from './basic-step'

export const SummaryStep = () => {
  const rootError = useAtomValue(errorAtom)
  const isUserRejectionError = useAtomValue(isUserRejectionErrorAtom)
  const errorToDisplay = getErrorToDisplay(rootError)
  const errorMessageToDisplay = errorToDisplay?.message

  const isSuccess = useAtomValue(isSuccessAtom)

  const [storedErrorMessage, setStoredErrorMessage] = useState(
    errorMessageToDisplay,
  )

  if (storedErrorMessage !== errorMessageToDisplay) {
    setStoredErrorMessage(errorMessageToDisplay)
  }

  return (
    <BasicStep
      title={'Trade failed'}
      isActive={false}
      isError={!!storedErrorMessage && !isUserRejectionError}
      isSuccess={isSuccess}
    >
      {storedErrorMessage && (
        <div className='flex flex-col text-left'>
          <span
            className='text-secondary text-sm leading-6'
            data-testid='error-reason'
          >
            <TradeErrorMessage error={storedErrorMessage} />
          </span>
        </div>
      )}
    </BasicStep>
  )
}
